export const HEALTH_RECORDS = () => {
  return {
    HEALTH_RECORDS: {//section
      HEALTH: {//QuestionsetCd
        YESNODATAELEMENT1: {//Dataelementcd
          question: 'Has any application for life, critical illness or health insurance on your life ever been declined, deferred or accepted with higher than standard premiums or an exclusion applied on health grounds?',
          answer: ''
        }
      },
      MEDICALDETAILS1: {
        FREETEXT1: {
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH: {
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3: {
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4: {
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION1:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION1:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
      HEALTH1: {
        YESNODATAELEMENT2: {
          question: 'Have you ever been incapable to work for more than 7 days or presently incapable to work?',
          answer: ''
        }
      },
      MEDICALDETAILS2:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION2:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION2:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
      OCCUPATIONRISK: {
        YESNODATAELEMENT2: {
          question: 'Do you expose yourself to any danger in the pursuance of your occupation (e.g. Chemical factory ,mines)',
          answer: ''
        },
        FREETEXT1:{
          question: 'Please specify',
          answer: ''
        }
      },
      DANGEROUSPURSUIT: {
        YESNODATAELEMENT3: {
          question: 'Do you intend to engage in any dangerous pursuits such as skydiving, parachuting, hang gliding, motor sports, diving, climbing, caving, or any other dangerous sports or are involved in aviation as a pilot, co-pilot, pilot instructor or student pilot?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Please specify',
          answer: ''
        }
      },
      TREATMENT:{
        FREETEXT1:{
          question: 'Have you ever had or received medical advice or treatment for any of the following?',
          answer: ''
        }
      },
      BLOODPRESSURE: {
        YESNODATAELEMENT1: {
          question: 'Disorders of blood pressure',
          answer: ''
        }
      },
      MEDICALDETAILS3: {
        FREETEXT1: {
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH: {
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3: {
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4: {
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION3: {
        YESNODATAELEMENT2: {
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION3:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
      OTHERDISEASES: {
        YESNODATAELEMENT1: {
          question: 'Disorders of chest pain, any heart disease, stroke, epilepsy, cancer (including skin cancers) or any tumor, lump, cyst, polyps or growth of any kind',
          answer: ''
        }
      },
      MEDICALDETAILS4:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION4:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT2:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION4:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
      BLOODSUGAR: {
        YESNODATAELEMENT1: {
          question: 'Raised blood sugars',
          answer: ''
        }
      },
      MEDICALDETAILS5:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION5:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION5:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
      OTHERDISEASES2: {
        YESNODATAELEMENT4: {
          question: 'Asthma or any respiratory disease, kidney or urinary tract disease, mental or any nervous disease, any liver disease, any blood disorders (including anaemia), any digestive and bowel disorder, raised blood sugars, any metabolic or endocrine disorder (including thyroid disorders), disorders of ears or eyes, problem of stones in any organ in the body',
          answer: ''
        }
      },
      MEDICALDETAILS6:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION6:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION6:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
      ANYDISORDER: {
        YESNODATAELEMENT2: {
          question: 'Any disorder of the bones, spine or muscle, auto immune diseases',
          answer: ''
        }
      },
      MEDICALDETAILS7:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION7:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION7:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
    
      HIVINFECTION: {
        YESNODATAELEMENT2: {
          question: 'HIV infection, AIDS or AIDS related complex, tuberculosis, lyme, alcohol or drug dependency',
          answer: ''
        }
      },
      MEDICALDETAILS8:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION8:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION8:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
    
      CONGENITAL: {
        YESNODATAELEMENT2: {
          question: 'Congenital/birth defects',
          answer: ''
        }
      },
      MEDICALDETAILS9:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION9:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION9:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
    
      HEALTHPROBLEM: {
        YESNODATAELEMENT2: {
          question: 'Are you currently receiving any medical treatment or do you intend seeking or have been advised to seek medical treatment for any health problems or are you waiting the results of any tests/investigations?',
          answer: ''
        }
      },
      MEDICALDETAILS10:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION10:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION10:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
    
      OTHERCONDITION: {
        YESNODATAELEMENT2: {
          question: 'Apart from condition listed, have you ever seen a Doctor or other health professional, or been prescribed medication for any other condition which has lasted for more than (apart from usual flue and colds) 5 days?',
          answer: ''
        }
      },
      MEDICALDETAILS11:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION11:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION11:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
    
      TERMINALDISEASE: {
        YESNODATAELEMENT3: {
          question: 'Has your biological mother, father, or any sister or brother been diagnosed prior to age 60 with any of the following? Cancer, Heart attack, Diabetes , Stroke, Huntington’s disease or any other inherited conditions?',
          answer: ''
        }
      },
      MEDICALDETAILS12:{
        FREETEXT1:{
          question: 'Medical Condition',
          answer: ''
        },
        NUMWITHSLASH:{
          question: 'Date of diagnosis',
          answer: ''
        },
        FREETEXT3:{
          question: 'Treatment given:',
          answer: ''
        },
        FREETEXT4:{
          question: 'Name of tablets or medications:',
          answer: ''
        }
      },
      HOSPITALIZATION12:{
        YESNODATAELEMENT2:{
          question: 'Have you ever been hospitalized for this condition?',
          answer: ''
        },
        FREETEXT1:{
          question: 'Date of hospitalisation',
          answer: ''
        }
      },
      MEDICALCOMPLETION12:{
        YESNODATAELEMENT9:{
          question: 'Have you now fully recovered and stopped all medications?',
          answer: ''
        },
        ALPHABETWITHSPECIALCHAR:{
          question: 'Please provide details',
          answer: ''
        }
      },
    
    }
  }
}